/* =================== HELPERS =================== */

// ATC button state
function setBtnState(btn, isAvailable) {
  if (!btn) return;
  btn.toggleAttribute('disabled', !isAvailable);
  btn.setAttribute('aria-disabled', String(!isAvailable));
  btn.classList.toggle('is-disabled', !isAvailable);
  btn.classList.toggle('disabled', !isAvailable);
  btn.classList.toggle('button--sold-out', !isAvailable);

  const sold = btn.querySelector('.sold-out-message');
  if (sold) sold.classList.toggle('hidden', isAvailable);
  btn.querySelectorAll('span:not(.sold-out-message)').forEach((s) => {
    s.classList.toggle('hidden', !isAvailable);
  });
}

// Send variant to all product forms
function pushVariantToForms(variant, { suppressEvent = false } = {}) {
  const productId = variant?.product_id;

  const scope =
    document.querySelector(`product-info[data-product-id="${productId || ''}"]`) ||
    document.querySelector('product-info') ||
    document;

  const forms = scope.querySelectorAll(
    'product-form form[action*="cart/add"], form[action*="/cart/add"]'
  );

  forms.forEach((form) => {
    const idInput = form.querySelector('input[name="id"]');
    if (idInput && variant) {
      idInput.value = variant.id;
      idInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });

  const atcButtons = scope.querySelectorAll(
    'product-form button[type="submit"], button[name="add"], .add-to-cart-btn, .product-form__submit'
  );
  const isAvail = !!(variant && variant.available);

  atcButtons.forEach((btn) => setBtnState(btn, isAvail));

  if (!suppressEvent && variant) {
    const evt = new CustomEvent('variant:change', {
      bubbles: true,
      detail: { variant, __fromCustomToggle: true },
    });
    scope.dispatchEvent(evt);
  }
}

// ml parsing
function parseMl(opt2) {
  if (!opt2) return Number.POSITIVE_INFINITY;
  const m = String(opt2).match(/(\d+(?:[.,]\d+)?)\s*ml/i);
  return m ? parseFloat(m[1].replace(',', '.')) : Number.POSITIVE_INFINITY;
}

// Money formatting
function formatMoney(cents) {
  if (window.Shopify && typeof Shopify.formatMoney === 'function') {
    try { return Shopify.formatMoney(cents); } catch (e) {}
  }
  return (cents / 100).toLocaleString('fi-FI', {
    style: 'currency',
    currency: 'EUR'
  });
}

// Discount %
function getDiscountPercent(variant) {
  const ca = Number(variant?.compare_at_price || 0);
  const p  = Number(variant?.price || 0);
  if (!ca || ca <= p) return 0;
  return Math.round((1 - p / ca) * 100);
}

// Dropdown option label builder
function buildOptionHTML(variant) {
  const pct = getDiscountPercent(variant);
  const size = variant.option2 || '';
  if (pct > 0) {
    return `
      <span class="size-label">${size}</span>
      <span class="discount-pill">-${pct}%</span>
    `;
  }
  return `<span class="size-label">${size}</span>`;
}

/* =================== PRICE UI (VERSION A MERGED) =================== */

function updateThemePriceUI(variant) {
  const scope =
    document.querySelector(`product-info[data-product-id="${variant?.product_id || ''}"]`) ||
    document.querySelector('product-info') ||
    document;

  const priceRoot = scope.querySelector('.price');
  if (!priceRoot || !variant) return;

  const hasDiscount = !!(variant.compare_at_price && variant.compare_at_price > variant.price);
  priceRoot.classList.toggle('price--on-sale', hasDiscount);

  const regularWrap = priceRoot.querySelector('.price__regular');
  const saleWrap    = priceRoot.querySelector('.price__sale');

  const saleEl =
    priceRoot.querySelector('.price-item--sale') ||
    priceRoot.querySelector('.price__sale .price-item--last');

  const compareEl =
    priceRoot.querySelector('.price__sale s.price-item--regular') ||
    priceRoot.querySelector('.price__compare .price-item');

  if (hasDiscount) {
    if (regularWrap) regularWrap.style.display = 'none';
    if (saleWrap)    saleWrap.style.display = '';

    if (saleEl)    saleEl.textContent    = formatMoney(variant.price);
    if (compareEl) compareEl.textContent = formatMoney(variant.compare_at_price);

    if (saleWrap && saleEl) {
      saleWrap.insertBefore(saleEl, saleWrap.firstElementChild || null);

      if (compareEl && compareEl.parentElement === saleWrap) {
        const cmpNode =
          compareEl.parentElement.tagName === 'SPAN'
            ? compareEl.parentElement
            : compareEl;
        saleWrap.insertBefore(cmpNode, saleEl.nextSibling);
      }
    }

  } else {
    if (regularWrap) regularWrap.style.display = '';
    if (saleWrap)    saleWrap.style.display = 'none';

    const regularItem =
      priceRoot.querySelector('.price__regular .price-item') ||
      priceRoot.querySelector('.price-item--regular');

    if (regularItem) regularItem.textContent = formatMoney(variant.price);
  }

  const unitRoot = priceRoot.querySelector('.unit-price');
  if (!unitRoot) return;

  const hasUnit = !!variant.unit_price && !!variant.unit_price_measurement;
  unitRoot.style.display = hasUnit ? '' : 'none';
  if (!hasUnit) return;

  const unitItem = unitRoot.querySelector('.price-item--last');
  if (!unitItem) return;

  const spans = unitItem.querySelectorAll('span');
  const valueSpan = spans[0];
  const refSpan   = spans[spans.length - 1];

  if (valueSpan) valueSpan.textContent = formatMoney(variant.unit_price);
  if (refSpan) {
    const refVal  = variant.unit_price_measurement.reference_value || 1;
    const refUnit = (variant.unit_price_measurement.reference_unit || '').toLowerCase();
    refSpan.textContent = `${refVal}${refUnit}`;
  }
}

/* =================== STOCK UI =================== */

function updateAvailabilityUI(variant) {
  const availRoot = document.getElementById('availability-dropdown');
  if (!availRoot || !variant) return;

  // Translation mapping
  const t = {
    in_stock:             availRoot.dataset.inStock || 'In stock',
    low_stock:            availRoot.dataset.lowStock || 'Low stock',
    out_of_stock:         availRoot.dataset.outOfStock || 'Out of stock',
    shipping_fast:        availRoot.dataset.shippingFast || 'Shipping: 1–3 working days',
    shipping_slow:        availRoot.dataset.shippingSlow || 'Shipping: 7–14 working days',

    // ✅ FIXED: this was missing!
    restock_possibility:  availRoot.dataset.restockPossibility || 'Restock maybe needed'
  };

  // Read inventory for current variant
  function getInventoryForVariant(id) {
    const el = document.querySelector(`.variant-data[data-variant-id="${id}"]`);
    return el ? Number(el.dataset.inventory) : 0;
  }

  const qty = getInventoryForVariant(variant.id);

  let colorClass = 'green';
  let statusText = t.in_stock;
  let shippingText = t.shipping_fast;
  let restockHtml = ''; // only filled when qty <= 0

  if (qty <= 0) {
    colorClass = 'red';
    statusText = t.out_of_stock;
    shippingText = t.shipping_slow;

    // 🔥 FIXED: correct class name + guaranteed translation
    restockHtml = `<div class="availability-restock">${t.restock_possibility}</div>`;
  } else if (qty <= 10) {
    colorClass = 'yellow';
    statusText = t.low_stock;
    shippingText = t.shipping_fast;
  }

  // Render UI
  availRoot.innerHTML = `
    <div class="availability-item" role="region" aria-live="polite">
      <span class="availability-left">
        <span class="circle ${colorClass}"></span>
        <span class="availability-text">${statusText}</span>
      </span>
      <div class="availability-shipping">${shippingText}</div>
      ${restockHtml}
    </div>
  `;
}


/* =================== MAIN LOGIC =================== */

document.addEventListener('DOMContentLoaded', () => {

  // Inject CSS for pills + availability
  (function injectCSS(){
    const css = `
      .custom-dropdown-list li{display:flex;align-items:center;justify-content:space-between;gap:8px;}
      .custom-dropdown-button #custom-dropdown-label{display:inline-flex;align-items:center;gap:8px;}
      .discount-pill{display:inline-block;padding:2px 6px;font-size:12px;font-weight:700;color:#fff;background:#ff5c5c;border-radius:3px;}
      .availability-item{display:flex;flex-direction:column;margin-top:8px;}
      .availability-left{display:flex;align-items:center;gap:8px;}
      .circle{width:12px;height:12px;border-radius:50%;}
      .circle.red{background:#e83b3b;}
      .circle.yellow{background:#ffb952;}
      .circle.green{background:#34c759;}
      @media(min-width:720px){
        .availability-item{flex-direction:column;}
      }
    `;
    const s = document.createElement('style');
    s.textContent = css;
    document.head.appendChild(s);
  })();

  const dataScript = document.querySelector('[type="application/json"][data-product]');
  if (!dataScript) return;

  const product = JSON.parse(dataScript.textContent);
  const variants = product.variants || [];

  const toggleBtns      = [...document.querySelectorAll('.variant-type-toggle')];
  const dropdownToggle  = document.getElementById('custom-dropdown-toggle');
  const dropdownLabel   = document.getElementById('custom-dropdown-label');
  const dropdownOptions = document.getElementById('custom-dropdown-options');
  const dropdownArrow   = document.querySelector('.custom-dropdown-arrow');
  const variantIdInput  = document.getElementById('custom-variant-id');

  function getVariantsByType(type) {
    return variants.filter((v) => v.option1 === type && v.available);
  }

  function updateImage(variant) {
    const img = document.querySelector('[data-product-featured-media]');
    if (!img || !variant.featured_image) return;
    img.src = variant.featured_image.src;
    img.alt = variant.featured_image.alt || '';
  }

  function syncShopifyVariantPicker(variant) {
    const selects = document.querySelectorAll('select[name^="options"]');
    if (!selects.length || !variant) return;

    const opts = [variant.option1, variant.option2, variant.option3];
    selects.forEach((select, i) => {
      const val = opts[i];
      if (!val) return;
      const opt = [...select.options].find(o => o.value.trim() === String(val).trim());
      if (opt) {
        select.value = opt.value;
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  }

  function applyVariant(variant, { suppressEvent = false } = {}) {
    updateImage(variant);
    syncShopifyVariantPicker(variant);
    updateThemePriceUI(variant);
    updateAvailabilityUI(variant);
    pushVariantToForms(variant, { suppressEvent });
  }

  function updateSizeDropdown(type) {
    const filtered = getVariantsByType(type)
      .sort((a, b) => parseMl(a.option2) - parseMl(b.option2));

    dropdownOptions.innerHTML = '';

    if (!filtered.length) {
      dropdownLabel.textContent = 'No sizes';
      if (variantIdInput) variantIdInput.value = '';
      pushVariantToForms(null, { suppressEvent: true });
      return;
    }

    filtered.forEach((variant) => {
      const li = document.createElement('li');
      li.innerHTML = buildOptionHTML(variant);
      li.dataset.variantId = variant.id;
      dropdownOptions.appendChild(li);
    });

    const first = filtered[0];
    dropdownLabel.innerHTML = buildOptionHTML(first);
    if (variantIdInput) variantIdInput.value = first.id;

    applyVariant(first);
  }

  toggleBtns.forEach((btn) => {
    btn.addEventListener('click', () => {
      toggleBtns.forEach((b) =>
        b.classList.toggle('active', b === btn)
      );
      updateSizeDropdown(btn.dataset.type);
      dropdownOptions.hidden = true;
      dropdownArrow.textContent = '▼';
    });
  });

  if (dropdownToggle) {
    dropdownToggle.addEventListener('click', () => {
      dropdownOptions.hidden = !dropdownOptions.hidden;
      dropdownArrow.textContent = dropdownOptions.hidden ? '▼' : '▲';
    });
  }

  dropdownOptions.addEventListener('click', (e) => {
    const li = e.target.closest('li');
    if (!li) return;

    const vid = li.dataset.variantId;
    const selected = variants.find((v) => String(v.id) === String(vid));

    dropdownLabel.innerHTML = li.innerHTML;
    if (variantIdInput) variantIdInput.value = vid;

    dropdownOptions.hidden = true;
    dropdownArrow.textContent = '▼';

    if (selected) applyVariant(selected);
  });

  const haveOriginal = getVariantsByType('Original').length > 0;
  const haveDecant   = getVariantsByType('Decant').length > 0;
  const initialType  = haveOriginal ? 'Original' : haveDecant ? 'Decant' : null;

  if (initialType) {
    toggleBtns.forEach((b) => b.classList.toggle(
      'active',
      b.dataset.type === initialType
    ));
    updateSizeDropdown(initialType);
  } else {
    pushVariantToForms(null, { suppressEvent: true });
  }

  document.addEventListener('variant:change', (evt) => {
    const v = evt.detail?.variant;
    if (!v) return;
    if (evt.detail.__fromCustomToggle) return;

    pushVariantToForms(v, { suppressEvent: true });
    updateThemePriceUI(v);
    updateAvailabilityUI(v);
  });
});
